import { render, staticRenderFns } from "./ActivationBriefOverviewView.vue?vue&type=template&id=0c47544a&scoped=true&"
import script from "./ActivationBriefOverviewView.vue?vue&type=script&lang=js&"
export * from "./ActivationBriefOverviewView.vue?vue&type=script&lang=js&"
import style0 from "./ActivationBriefOverviewView.vue?vue&type=style&index=0&id=0c47544a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c47544a",
  null
  
)

export default component.exports